import React from 'react'

const MiniUserCard = () => {
    return (
        <div className="mini-user-card">
            <div className="userpp">
                <img src="./img/Group-884.png"/>
            </div>
            <div className="mini-user-card-right">
                <div className="mini-user-card-name"><b>escommerce</b></div>
                <span>1h ago | by EmbedSocial</span>
            </div>
        </div>
    )
}
export default MiniUserCard;